/**
 * Case Pass product definitions — split out from `case-pass.ts` so client
 * components (e.g. the `/pricing` page) can import pricing without
 * pulling in `case-pass.ts`'s server-only activation logic, which imports
 * `@/lib/notifications/routing` -> `@/lib/push/send` -> the `web-push`
 * package (Node-only, requires `tls`/`net`) and breaks the client bundle.
 */

export const CASE_PASS_OPTIONS = [
  {
    id: 'six_month',
    name: '6 Month Case Pass',
    priceInr: 599,
    termMonths: 6,
  },
  {
    id: 'yearly',
    name: 'Yearly Case Pass',
    priceInr: 999,
    termMonths: 12,
  },
] as const;

export type CasePassOption = (typeof CASE_PASS_OPTIONS)[number];
export type CasePassTermMonths = CasePassOption['termMonths'];

export const SIX_MONTH_CASE_PASS = CASE_PASS_OPTIONS[0];
export const YEARLY_CASE_PASS = CASE_PASS_OPTIONS[1];

/** Default used by compact in-product checkout surfaces and renewal links. */
export const CASE_PASS_PRICE_INR = YEARLY_CASE_PASS.priceInr;
export const CASE_PASS_TERM_MONTHS = YEARLY_CASE_PASS.termMonths;

/** Captured or still-payable passes sold before the 2026-08-03 price change. */
export const LEGACY_CASE_PASS_PRICE_INR = 499;

export function getCasePassOptionByTermMonths(
  termMonths: number,
): CasePassOption | null {
  return CASE_PASS_OPTIONS.find((option) => option.termMonths === termMonths) || null;
}

export function isSupportedCasePassProduct(
  amountInr: number,
  termMonths: number,
): boolean {
  return CASE_PASS_OPTIONS.some((option) => (
    option.priceInr === amountInr && option.termMonths === termMonths
  )) || (
    amountInr === LEGACY_CASE_PASS_PRICE_INR && termMonths === 12
  );
}
